import React from 'react';

import { AdminCreateUserModal } from '@/components/admin/AdminCreateUserModal';
import { AdminUsersTable } from './AdminUsersTable';
import { Button } from '@/components/ui';
import { canManageUsers } from '@/lib/roles';
import type { User } from '@/lib/types/core';

type Props = {
  currentUser: Pick<User, 'id' | 'roles' | 'is_active'> | null;
  users: User[];
  includeProvisioning?: boolean;
};

export function AdminUsersPage({ currentUser, users, includeProvisioning = false }: Props) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  if (!canManageUsers(currentUser)) return null;

  return (
    <div className="max-w-md mx-auto py-6 px-4 space-y-6 min-h-screen bg-[#f5f7f8]">
      <div className="bg-[#e8f5f0] border border-[#006855]/10 rounded-2xl p-5 mb-4 flex items-center justify-between gap-4">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[2px] text-[#006855]/70 mb-1">USER MANAGEMENT</div>
          <h1 className="text-[22px] font-extrabold text-[#2c2f30] leading-tight">Admin Users</h1>
        </div>
        {includeProvisioning && (
          <Button
            onClick={() => setIsModalOpen(true)}
            className="bg-[#006855] border-[#006855] text-white hover:bg-[#005b4a] hover:border-[#005b4a] shrink-0"
            size="sm"
          >
            New user
          </Button>
        )}
      </div>

      <AdminUsersTable users={users} />

      <AdminCreateUserModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
